import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "authentication"

  connect() {
    super.connect()
    this.notifyBridgeOfAuthState()
  }

  notifyBridgeOfAuthState() {
    const authenticated = this.element.dataset.bridgeAuthenticated === "true"
    this.send(authenticated ? "signIn" : "signOut", {})
  }
}
